<script>
import UserResource from '@/resources/user'
import ModalTakeAppointment from '@/common/components/Modal/TakeAppointment'
import timespanpicker from '@/components/timespanpicker'

export default {
	name: 'Activity',
	components: {
		timespanpicker
	},
	data () {
		return {
			rowData: [],
			baseDate: new Date(),
			span: 'all',
			modalTakeAppointment: ModalTakeAppointment,
			showTakeAppointment: false,
			rdvToEdit: null
		}
	},
	created () {
		this.fetchAppointments()
	},
	methods: {
		fetchAppointments () {
			UserResource.fetchAppointments().then((result) => {
				if (result.data.success) {
					console.log('result.data.rdvs', result.data.rdvs);
					const parsedData = result.data.rdvs.map((rdv) => ({
						date: this.parseDate(rdv.start_date),
						hour: {
							start: this.parseDate(rdv.start_date),
							end: this.parseDate(rdv.end_date)
						},
						type: rdv.type,
						description: rdv.description || null,
						customer: rdv.client.user.first_name + ' ' + rdv.client.user.last_name,
						clientId: rdv.client.user.id,
						clientPhone: rdv.client.user.phone || null,
						clientEmail: rdv.client.user.email || null,
						id: rdv.id
					}))
					this.rowData = parsedData
				}
			}).catch((error) => {
				console.error('Erreur fetchAppointments:', error)
			})
		},
		formatDay (date) {
			return this.$moment(date).format('ddd')
		},
		formatDate (date) {
			return this.$moment(date).format('DD MMM YYYY')
		},
		formatHour (date) {
			return this.$moment(date).format('HH:mm')
		},
		getTypeBadgeClass (type) {
			switch (type) {
			case 'Visio Call':
				return 'appointments-list__type-badge--visio'
			case 'Rendez-vous':
				return 'appointments-list__type-badge--rdv'
			case 'Appel téléphonique':
				return 'appointments-list__type-badge--phone'
			default:
				return ''
			}
		},
		setDate (value) {
			switch (this.span) {
			case 'day':
				this.baseDate = new Date(this.baseDate.setDate(this.baseDate.getDate() + value))
				break
			case 'week':
				this.baseDate = new Date(this.baseDate.setDate(this.baseDate.getDate() + (7 * value)))
				break
			case 'month':
				this.baseDate = new Date(this.baseDate.setMonth(this.baseDate.getMonth() + value))
				break
			case 'year':
				this.baseDate = new Date(this.baseDate.setFullYear(this.baseDate.getFullYear() + value))
				break
			}
		},
		setSpan (value) {
			this.span = value
		},
		parseDate (date) {
			date = date.split(' ')
			let d = date[0].split('/')
			d = d.concat(date[1].split(':'))
			return new Date(d[2], d[1] - 1, d[0], d[3], d[4])
		},
		deleteRdv (rdv) {
			if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
				this.$store.dispatch('removeAppointment', rdv.id).then(() => {
					this.fetchAppointments()
				})
			}
		},
		editRdv (rdv) {
			this.rdvToEdit = rdv
			this.showTakeAppointment = true
		},
		closeTakeAppointment () {
			this.showTakeAppointment = false
			this.rdvToEdit = null
			this.fetchAppointments()
		}
	},
	computed: {
		rowDataFiltered () {
			let result = []
			let tmp = null
			let start = null
			let end = null

			switch (this.span) {
			case 'day':
				result = this.rowData.filter((row) => {
					return (row.date.getDate() === this.baseDate.getDate() && row.date.getMonth() === this.baseDate.getMonth() && row.date.getFullYear() === this.baseDate.getFullYear())
				})
				break
			case 'week':
				tmp = new Date(this.baseDate)
				start = this.$moment(tmp.setDate(tmp.getDate() - tmp.getDay() + 1))
				end = this.$moment(tmp.setDate(tmp.getDate() + 7 - tmp.getDay()))
				result = this.rowData.filter((row) => {
					return (this.$moment(row.date) >= start && this.$moment(row.date) <= end)
				})
				break
			case 'month':
				result = this.rowData.filter((row) => {
					return (row.date.getMonth() === this.baseDate.getMonth() && row.date.getFullYear() === this.baseDate.getFullYear())
				})
				break
			case 'year':
				result = this.rowData.filter((row) => {
					return (row.date.getFullYear() === this.baseDate.getFullYear())
				})
				break
			case 'all':
				result = [...this.rowData]
				break
			}
			// Tri par date du plus lointain au plus proche
			return result.sort((a, b) => b.date - a.date)
		},
		currentFilter () {
			let value = null
			const tmp = new Date(this.baseDate)
			switch (this.span) {
			case 'day':
				value = this.$moment(this.baseDate).format('DD MMMM YYYY')
				break
			case 'week':
				const start = this.$moment(tmp.setDate(tmp.getDate() - tmp.getDay() + 1)).format('DD MMMM')
				const end = this.$moment(tmp.setDate(tmp.getDate() + 7 - tmp.getDay())).format('DD MMMM YYYY')
				value = `du ${start} au ${end}`
				break
			case 'month':
				value = this.$moment(this.baseDate).format('MMMM YYYY')
				break
			case 'year':
				value = this.$moment(this.baseDate).format('YYYY')
				break
			case 'all':
				value = ''
			}

			return value
		}
	}
}
</script>

<template lang="html">
  <section class="take-place column activity-container">
		<div class="header-table row">
			<div class="ctn-day-picker row">
				<timespanpicker @change="setSpan"/>

				<template v-if="span !== 'all'">
				<div class="ctn-arrow" @click="setDate(-1)">
					<span class="icon-left-open-mini"></span>
				</div>
				<div class="ctn-arrow" @click="setDate(1)">
					<span class="icon-right-open-mini"></span>
				</div>
			</template>
				<div class="bold">
					{{ currentFilter }}
				</div>
			</div>
			<div class="ctn-plan-rdv" @click="showTakeAppointment=true">
				<div class="btn btn-red">
					<span class="icon-button-rdv"></span> Planifier un RDV
				</div>
			</div>
		</div>

		<!-- Liste des rendez-vous -->
		<div class="appointments-list">
			<div class="appointments-list__header">
				<span class="appointments-list__col appointments-list__col--date">Date</span>
				<span class="appointments-list__col appointments-list__col--hour">Horaire</span>
				<span class="appointments-list__col appointments-list__col--type">Type</span>
				<span class="appointments-list__col appointments-list__col--customer">Client</span>
				<span class="appointments-list__col appointments-list__col--description">description</span>
				<span class="appointments-list__col appointments-list__col--contact">Contact</span>
				<span class="appointments-list__col appointments-list__col--actions"></span>
			</div>

			<div v-if="rowDataFiltered.length === 0" class="appointments-list__empty">
				<span class="icon-calendar"></span>
				<p>Aucun rendez-vous prévu</p>
			</div>

			<div
				v-for="rdv in rowDataFiltered"
				:key="rdv.id"
				class="appointments-list__item"
			>
				<div class="appointments-list__col appointments-list__col--date">
					<span class="appointments-list__day">{{ formatDay(rdv.date) }}</span>
					<span class="appointments-list__date-full">{{ formatDate(rdv.date) }}</span>
				</div>

				<div class="appointments-list__col appointments-list__col--hour">
					<span class="appointments-list__time">
						{{ formatHour(rdv.hour.start) }} - {{ formatHour(rdv.hour.end) }}
					</span>
				</div>

				<div class="appointments-list__col appointments-list__col--type">
					<span
						class="appointments-list__type-badge"
						:class="getTypeBadgeClass(rdv.type)"
					>
						<span class="appointments-list__type-dot"></span>
						{{ rdv.type }}
					</span>
				</div>

				<div class="appointments-list__col appointments-list__col--customer">
					<router-link
						:to="{ name: 'Client', params: { clientId: rdv.clientId } }"
						class="appointments-list__customer-link"
					>
						{{ rdv.customer }}
					</router-link>
				</div>
				<div class="appointments-list__col appointments-list__col--description">
						{{ rdv.description }}
				</div>
				<div class="appointments-list__col appointments-list__col--contact">
					<div class="appointments-list__contact-info">
						<a v-if="rdv.clientPhone" :href="'tel:' + rdv.clientPhone" class="appointments-list__contact-pill appointments-list__contact-pill--phone">
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
							</svg>
							<span>{{ rdv.clientPhone }}</span>
						</a>
						<a v-if="rdv.clientEmail" :href="'mailto:' + rdv.clientEmail" class="appointments-list__contact-pill appointments-list__contact-pill--email">
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
								<polyline points="22,6 12,13 2,6"/>
							</svg>
							<span>{{ rdv.clientEmail }}</span>
						</a>
						<span v-if="!rdv.clientPhone && !rdv.clientEmail" class="appointments-list__no-contact">-</span>
					</div>
				</div>

				<div class="appointments-list__col appointments-list__col--actions">
					<button
						class="appointments-list__edit-btn"
						@click="editRdv(rdv)"
						title="Modifier le rendez-vous"
					>
						<span class="icon-file-edit"></span>
					</button>
					<button
						class="appointments-list__delete-btn"
						@click="deleteRdv(rdv)"
						title="Supprimer le rendez-vous"
					>
						<span class="icon-file-trash"></span>
					</button>
				</div>
			</div>
		</div>

		<base-modal :show="showTakeAppointment" @close="closeTakeAppointment" :content="modalTakeAppointment" :data="rdvToEdit ? { rdv: rdvToEdit } : null" />
  </section>
</template>

<style lang="scss" scoped>
.appointments-list {
	width: 100%;
	padding: 0 1rem;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	overflow: hidden;
	margin-top: 1rem;

	&__header {
		display: grid;
		grid-template-columns: 140px 120px  190px  150px 1fr 180px 90px;
		gap: 1rem;
		padding: 1rem 1.5rem;
		background: #f8f9fa;
		border-bottom: 1px solid #e9ecef;
		font-size: 0.75rem;
		font-weight: 600;
		color: #6c757d;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	&__empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 4rem 2rem;
		color: #adb5bd;

		span {
			font-size: 3rem;
			margin-bottom: 1rem;
		}

		p {
			font-size: 1rem;
			margin: 0;
		}
	}

	&__item {
		display: grid;
		grid-template-columns: 140px 120px  190px  150px 1fr 180px 90px;
		gap: 1rem;
		padding: 1rem 1.5rem;
		border-bottom: 1px solid #f1f3f4;
		align-items: center;
		transition: background-color 0.2s ease;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background-color: #f8f9fa;
		}
	}

	&__col {
		display: flex;
		align-items: center;

		&--date {
			flex-direction: column;
			align-items: flex-start;
		}

		&--actions {
			justify-content: flex-end;
			gap: 0.25rem;
		}
	}

	&__day {
		font-size: 0.7rem;
		font-weight: 600;
		color: #6c757d;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	&__date-full {
		font-size: 0.9rem;
		font-weight: 500;
		color: #212529;
	}

	&__time {
		font-size: 0.9rem;
		font-weight: 500;
		color: #495057;
		background: #f1f3f4;
		padding: 0.35rem 0.75rem;
		border-radius: 6px;
	}

	&__type-badge {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		font-size: 0.85rem;
		font-weight: 500;
		padding: 0.4rem 0.85rem;
		border-radius: 20px;
		background: #f1f3f4;
		color: #495057;

		&--visio {
			background: rgba(139, 69, 19, 0.1);
			color: #8b4513;

			.appointments-list__type-dot {
				background: #8b4513;
			}
		}

		&--rdv {
			background: rgba(59, 130, 246, 0.1);
			color: #3b82f6;

			.appointments-list__type-dot {
				background: #3b82f6;
			}
		}

		&--phone {
			background: rgba(239, 68, 68, 0.1);
			color: #ef4444;

			.appointments-list__type-dot {
				background: #ef4444;
			}
		}
	}

	&__type-dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #6c757d;
	}

	&__customer-link {
		font-size: 0.9rem;
		font-weight: 500;
		color: #212529;
		text-decoration: none;
		transition: color 0.2s ease;

		&:hover {
			color: #AF9376;
			text-decoration: underline;
		}
	}

	&__contact-info {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	&__contact-pill {
		display: inline-flex;
		align-items: center;
		gap: 0.4rem;
		padding: 0.35rem 0.7rem;
		border-radius: 20px;
		font-size: 0.8rem;
		font-weight: 500;
		text-decoration: none;
		transition: all 0.2s ease;

		svg {
			flex-shrink: 0;
		}

		span {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 140px;
		}

		&--phone {
			background: rgba(16, 185, 129, 0.1);
			color: #059669;

			&:hover {
				background: rgba(16, 185, 129, 0.2);
				color: #047857;
			}
		}

		&--email {
			background: rgba(59, 130, 246, 0.1);
			color: #2563eb;

			&:hover {
				background: rgba(59, 130, 246, 0.2);
				color: #1d4ed8;
			}
		}
	}

	&__no-contact {
		font-size: 0.85rem;
		color: #adb5bd;
	}

	&__edit-btn,
	&__delete-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		border: none;
		background: transparent;
		color: #adb5bd;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;

		span {
			font-size: 1.1rem;
		}
	}

	&__edit-btn {
		&:hover {
			background: rgba(175, 147, 118, 0.1);
			color: #AF9376;
		}
	}

	&__delete-btn {
		&:hover {
			background: rgba(239, 68, 68, 0.1);
			color: #ef4444;
		}
	}
}
</style>



// WEBPACK FOOTER //
// Activity.vue?20b2a061